import React from 'react'
import PropTypes from 'prop-types'
import parseGGDriver from '../../../helpers/parseGGDriver'

class DesignFrontCol extends React.PureComponent {

    render() {
        const {designBack, productStatus} = this.props
        const _designBack = parseGGDriver(designBack || '')
        const displayField = productStatus !== 'cancelled' ? 'notDisableCancel DesignBack' : 'DesignBack'

        return (
            <div className={displayField}>
                {_designBack &&
                <a href={_designBack} target='_blank' rel='noopener noreferrer'><u>B</u>ack<br/>Mặt SAU</a>}
            </div>
        )
    }
}

DesignFrontCol.propTypes = {
    productStatus:PropTypes.string,
    designFront: PropTypes.string,
}

export default DesignFrontCol
